module.exports = __webpack_public_path__ + "static/media/9x12no2.d76daa20.jpg";